import script from "./CreateNormalEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateNormalEvent.vue?vue&type=script&setup=true&lang=ts"

import "./CreateNormalEvent.vue?vue&type=style&index=0&id=78b95530&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b95530"]])

export default __exports__